
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/3square","xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"3square","fill":"#697485"}},[_c('path',{attrs:{"d":"M3.465 8.438h1.786a.563.563 0 01.563.563v1.777c0 1.094.315 1.41 1.4 1.41h1.787a.563.563 0 01.563.563v1.784a2.536 2.536 0 01-.623 1.907 2.553 2.553 0 01-1.912.621H3.465a2.54 2.54 0 01-1.906-.621 2.54 2.54 0 01-.621-1.907v-3.562a2.553 2.553 0 01.621-1.912 2.536 2.536 0 011.906-.623zm1.223 1.125H3.465c-1.087 0-1.402.316-1.402 1.41v3.562c0 1.088.315 1.4 1.4 1.4h3.565c1.094 0 1.41-.315 1.41-1.4v-1.222H7.216a2.536 2.536 0 01-1.907-.625 2.553 2.553 0 01-.621-1.91z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M7.215 4.688h1.786a.563.563 0 01.563.563v1.777c0 1.094.315 1.41 1.4 1.41h1.787a.563.563 0 01.563.563v1.777a2.549 2.549 0 01-.622 1.913 2.549 2.549 0 01-1.913.622H7.215a2.536 2.536 0 01-1.906-.623 2.553 2.553 0 01-.621-1.912V7.215a2.54 2.54 0 01.621-1.906 2.54 2.54 0 011.906-.621zm1.223 1.125H7.215c-1.087 0-1.402.315-1.402 1.402v3.563c0 1.094.315 1.41 1.4 1.41h3.565c1.094 0 1.41-.316 1.41-1.41V9.563h-1.222a2.536 2.536 0 01-1.907-.625 2.553 2.553 0 01-.621-1.91z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10.965.938h3.563a2.553 2.553 0 011.912.621 2.536 2.536 0 01.623 1.907v3.562a2.549 2.549 0 01-.622 1.913 2.549 2.549 0 01-1.913.622h-3.563a2.536 2.536 0 01-1.906-.623 2.553 2.553 0 01-.621-1.912V3.465a2.54 2.54 0 01.621-1.906 2.54 2.54 0 011.906-.621zm3.563 7.5c1.094 0 1.41-.316 1.41-1.41V3.465c0-1.088-.316-1.4-1.41-1.4h-3.563c-1.087-.002-1.402.313-1.402 1.4v3.563c0 1.094.315 1.41 1.4 1.41z"}})])])
          )
        }
      }
    